
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class LoggedinServiceBehavior {

  //https://medium.com/@weswhite/angular-behaviorsubject-service-60485ef064fc

  constructor() { }

  private loggedinAnnouncedSourceBehavior = new BehaviorSubject<boolean>(null);
  // Observable string streams
  loggedinAnnouncedBehavior = this.loggedinAnnouncedSourceBehavior.asObservable();
  // Service message commands
  announceLoggedin(loggedin: boolean) {
    this.loggedinAnnouncedSourceBehavior.next(loggedin);
  }

} 